export const translations = {
  tr: {
    // Navigation
    nav: {
      problem: 'Problem',
      features: 'Özellikler',
      howItWorks: 'Nasıl Çalışır',
      pricing: 'Fiyatlandırma',
      developer: 'Developer',
      login: 'Giriş Yap',
      requestDemo: 'Demo Talep Et',
    },

    // Hero Section
    hero: {
      badge: 'Ödeme Kontrol Platformu',
      titlePart1: 'Sessizce Kaybolan',
      titleHighlight: ' Gelirlerinizi ',
      titlePart2: 'Gün Yüzüne Çıkarın',
      description: 'Ödeme altyapınızdaki her işlemi uçtan uca izleyin. Kayıp, yinelenen veya hatalı ödemeleri',
      descriptionBold: 'kanıtlanabilir',
      descriptionEnd: 'şekilde tespit edin.',
      stat1Value: '%',
      stat1Label: 'Ortalama Gelir Kaybı',
      stat2Value: ' dk',
      stat2Label: 'Tespit Süresi',
      stat3Value: '%',
      stat3Label: 'Doğruluk Oranı',
      ctaPrimary: 'Ücretsiz Dene',
      ctaSecondary: 'Demo İzle',
      trustedBy: 'Güvenilen Markalar:',
    },

    // Problem Section
    problem: {
      tag: 'Problem',
      title: 'Modern Ödeme Sistemlerinin',
      titleHighlight: 'Karanlık Noktası',
      subtitle: 'Dağıtık sistemlerde ödeme akışları karmaşıklaşır. Log\'larda kaybolan hatalar, sessizce gelir kaybına dönüşür.',
      cards: [
        {
          emoji: '💸',
          title: 'Sessiz Gelir Kaybı',
          description: 'Provider başarılı diyor ama sipariş oluşmamış. Kimse fark etmiyor, para kayboluyor.',
        },
        {
          emoji: '🔄',
          title: 'Çift İşlem Riski',
          description: 'Webhook birden fazla kez geldi, retry yüzünden aynı ödeme iki kez işlendi.',
        },
        {
          emoji: '📱',
          title: 'Mobile Kopukluk',
          description: 'Uygulama kapandı, ödeme yarım kaldı. Kullanıcı parasını ödedi ama hizmet alamadı.',
        },
        {
          emoji: '⏱️',
          title: 'Async Kaos',
          description: 'Load balancer altında state kayboldu. Queue backlog oluştu, ödemeler gecikti.',
        },
        {
          emoji: '🔍',
          title: 'Log Cehenneminde Kayıp',
          description: 'Binlerce satır log var ama hangi ödeme neden başarısız bilinmiyor.',
        },
        {
          emoji: '📊',
          title: 'Görünmez %1-5',
          description: 'Şirketler ortalama %1-5 gelir kaybını fark etmiyor. Ayda binlerce dolar uçuyor.',
        },
      ],
    },

    // Features Section
    features: {
      tag: 'Özellikler',
      title: 'Tek Platform,',
      titleHighlight: 'Tam Görünürlük',
      subtitle: 'Ödeme lifecycle\'ının her adımını izleyin, anomalileri anında tespit edin.',
      cards: [
        {
          title: 'Payment Timeline',
          description: 'Her ödeme için kronolojik state akışı. INIT\'den REVENUE\'ya kadar her adım görünür.',
        },
        {
          title: 'Kayıp Gelir Tespiti',
          description: 'Provider success var ama DB\'de kayıt yok? Anında uyarı ve tahmini kayıp tutarı.',
        },
        {
          title: 'Webhook Tracking',
          description: 'Gelen her webhook kaydedilir. Retry sayısı, işlenme durumu, timing analizi.',
        },
        {
          title: 'State Machine Validation',
          description: 'Geçersiz state geçişlerini yakalar. INIT olmadan SUCCESS? Anında flag.',
        },
        {
          title: 'Duplicate Detection',
          description: 'Aynı ödeme için çift webhook veya çift gelir kaydı? Risk seviyesiyle birlikte uyarı.',
        },
        {
          title: 'AI Açıklama Motoru',
          description: 'Neden bu hafta kayıplar arttı? AI, pattern\'leri analiz eder, insan dilinde açıklar.',
        },
      ],
      highlight: {
        title: 'State Akışı Bozulduğunda',
        description: 'Sistem otomatik olarak anomaliyi tespit eder, tahmini kayıp tutarını hesaplar ve aksiyonları önerir.',
        features: ['Gerçek zamanlı tespit', 'Confidence score hesaplama', 'Öneri motoru'],
      },
    },

    // How It Works Section
    howItWorks: {
      tag: 'Nasıl Çalışır',
      title: '3 Adımda',
      titleHighlight: 'Tam Görünürlük',
      subtitle: 'Entegrasyon dakikalar içinde tamamlanır. Core ödeme akışınıza müdahale etmez.',
      steps: [
        {
          number: '01',
          title: 'SDK Entegrasyonu',
          description: 'Backend\'inize küçük bir SDK ekleyin. Async ve non-blocking çalışır, performansı etkilemez.',
        },
        {
          number: '02',
          title: 'Webhook Bağlantısı',
          description: 'Ödemeler her zaman kaybolmaz… Bazıları sessizce eksik kalır.',
        },
        {
          number: '03',
          title: 'Dashboard\'dan İzleyin',
          description: 'Gerçek zamanlı olarak tüm ödemeleri izleyin, anomalileri anında görün, raporları indirin.',
        },
      ],
      webhook: {
        provider: 'Payment Provider',
        yourApi: 'Sizin API',
      },
      metrics: {
        total: 'Toplam Ödeme',
        healthy: 'Sağlıklı',
        risky: 'Riskli',
        lost: 'Kayıp',
      },
      note: {
        title: 'Observer / Sidecar Mimarisi',
        description: 'SilentLoss sisteminizin',
        descriptionBold: 'yanında',
        descriptionEnd: 'çalışır, asla müdahale etmez. Fail olsa bile ödemeleriniz etkilenmez. %100 güvenli entegrasyon.',
      },
      // Animation Flow
      animation: {
        scenarioHealthy: 'Başarılı Ödeme Akışı',
        scenarioLoss: 'Sessiz Kayıp Senaryosu',
        // Events
        events: {
          paymentInitiated: 'payment.initiated',
          processingPayment: 'provider.processing',
          providerSuccess: 'provider.success',
          merchantRecorded: 'merchant.recorded',
          silentlossConfirmed: 'silentloss.confirmed',
        },
        // Labels
        labels: {
          client: 'Müşteri Uygulaması',
          provider: 'Payment Provider',
          merchantServer: 'Merchant Server',
          silentloss: 'SilentLoss',
        },
        // Status messages
        status: {
          initiating: 'Ödeme Başlatılıyor',
          processing: 'İşleniyor...',
          success: 'Başarılı',
          recorded: 'Kaydedildi',
          confirmed: 'Doğrulandı',
          waiting: 'Bekleniyor...',
          missing: 'Eksik Event',
          detected: 'Tespit Edildi',
        },
        // Final messages
        healthyMessage: {
          title: 'Her Şey Yolunda',
          subtitle: 'Kayıp ödeme tespit edilmedi.',
        },
        lossMessage: {
          title: 'Sessiz Kayıp Tespit Edildi',
          subtitle: 'Ödeme başarılı ama kaydedilmemiş.',
          detail: 'Bu işlem normalde fark edilmezdi.',
        },
        // CTA
        cta: {
          title: 'Sessizce para kaybetmeyin.',
          subtitle: 'Ödeme boşluklarını kullanıcılarınızdan önce tespit edin.',
        },
      },
    },

    // Dashboard Section
    dashboard: {
      tag: 'Dashboard',
      title: 'Her Ödemenin',
      titleHighlight: 'Hikayesini Görün',
      windowTitle: 'SilentLoss Dashboard',
      sidebar: {
        overview: 'Overview',
        payments: 'Ödemeler',
        risks: 'Riskler',
        reports: 'Raporlar',
      },
      stats: {
        totalPayment: 'Toplam Ödeme',
        healthy: 'Sağlıklı',
        estimatedLoss: 'Tahmini Kayıp',
        thisWeek: 'Bu hafta',
      },
      chart: {
        title: 'Ödeme Durumu (Son 7 Gün)',
        days: ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'],
      },
      timeline: {
        title: 'Son Tespit Edilen Problemler',
        lostRevenue: 'Kayıp gelir',
        doubleWebhook: 'Çift webhook',
        stateMismatch: 'State mismatch',
        timeout: 'Timeout',
      },
    },

    // AI Section
    ai: {
      tag: 'AI Destekli',
      title: 'Neden Kaybettiğinizi',
      titleHighlight: 'Anlayın',
      description: 'AI motoru sadece "kayıp var" demez. Pattern\'leri analiz eder, root cause\'u bulur, aksiyonları önerir.',
      quote: '"Bu dönemde ödeme kayıplarının',
      quoteBold1: '%70\'i',
      quoteMiddle: 'cuma 20:00–22:00 saatlerinde,',
      quoteBold2: 'load balancer retry\'ları',
      quoteEnd: 'nedeniyle oluşmuştur. Webhook timeout threshold\'unuzu 5 saniyeden 10 saniyeye çıkarmanızı öneririm."',
      meta: 'SilentLoss AI • Haftalık Analiz',
      capabilities: [
        'Anomali pattern tespiti',
        'Root cause analizi',
        'CFO-friendly özet raporlar',
        'Aksiyon önerileri',
      ],
      card: {
        title: 'Haftalık AI Özeti',
        new: 'Yeni',
        insights: [
          { title: 'Kayıp Trend', value: '-23% (geçen haftaya göre)' },
          { title: 'Ana Pattern', value: 'Mobile timeout (iOS 17+)' },
          { title: 'Önerilen Aksiyon', value: 'SDK timeout: 10s → 15s' },
        ],
      },
    },

    // Pricing Section
    pricing: {
      tag: 'Fiyatlandırma',
      title: 'Şeffaf',
      titleHighlight: 'Fiyatlandırma',
      subtitle: 'Ödeme sayınıza göre ölçeklenen, öngörülebilir fiyatlandırma.',
      perMonth: '/ay',
      paymentsPerMonth: 'ödeme/ay',
      popular: 'En Popüler',
      selectButton: 'Seç',
      startButton: 'Hemen Başla',
      plans: [
        {
          name: 'Free Trial',
          price: 0,
          isFree: true,
          payments: '1.000',
          features: [
            '7 Gün Ücretsiz Deneme',
            '1 Ekip Üyesi',
            '7 Gün Veri Saklama',
            'Payment Tracking',
            'Webhook Tracking',
            'Risk Detection',
          ],
        },
        {
          name: 'Basic',
          price: 19,
          payments: '5.000',
          features: [
            '2 Ekip Üyesi',
            '14 Gün Veri Saklama',
            'Payment Tracking',
            'Webhook Tracking',
            'Risk Detection',
            'Basic Dashboard',
          ],
        },
        {
          name: 'Standard',
          price: 49,
          payments: '20.000',
          popular: true,
          features: [
            '5 Ekip Üyesi',
            '60 Gün Veri Saklama',
            'Payment Tracking',
            'Webhook Tracking',
            'Risk Detection',
            'Risk Factor Comparison',
            'CSV Export',
          ],
        },
        {
          name: 'Pro',
          price: 99,
          payments: '75.000',
          features: [
            '10 Ekip Üyesi',
            '180 Gün Veri Saklama',
            'Payment Tracking',
            'Webhook Tracking',
            'Risk Detection',
            'Org Level Stats',
            'Risk Factor Comparison',
            'CSV Export',
          ],
        },
      ],
      audit: {
        title: 'Audit Mode',
        description: 'Sisteminizi 7-14 gün izleyelim, detaylı PDF rapor üretelim. Tek seferlik ücret.',
        price: '$1,000 - $5,000',
        button: 'Teklif Al',
      },
    },

    // CTA Section
    cta: {
      title: 'Kaybolan Gelirlerinizi',
      titleHighlight: 'Bugün',
      titleEnd: 'Keşfedin',
      description: '14 gün ücretsiz deneyin. Kredi kartı gerekmez. 5 dakikada entegre edin.',
      primaryButton: 'Ücretsiz Başla',
      secondaryButton: 'Demo Planla',
      trust: {
        gdpr: 'GDPR & KVKK Uyumlu',
        pci: 'PCI Scope Dışı',
        uptime: '%99.9 Uptime',
      },
    },

    // Footer
    footer: {
      description: 'Ödeme altyapınızdaki sessiz gelir kayıplarını ortaya çıkaran gözlem ve doğrulama platformu.',
      product: {
        title: 'Ürün',
        features: 'Özellikler',
        pricing: 'Fiyatlandırma',
        howItWorks: 'Nasıl Çalışır',
        documentation: 'Dokümantasyon',
      },
      company: {
        title: 'Şirket',
        about: 'Hakkımızda',
        blog: 'Blog',
        careers: 'Kariyer',
        contact: 'İletişim',
      },
      support: {
        title: 'Destek',
        helpCenter: 'Yardım Merkezi',
        apiReference: 'API Referans',
        status: 'Status',
        security: 'Güvenlik',
      },
      legal: {
        copyright: '© 2026 SilentLoss. Tüm hakları saklıdır.',
        privacy: 'Gizlilik Politikası',
        terms: 'Kullanım Şartları',
        kvkk: 'KVKK',
      },
    },
  },

  en: {
    // Navigation
    nav: {
      problem: 'Problem',
      features: 'Features',
      howItWorks: 'How It Works',
      pricing: 'Pricing',
      developer: 'Developer',
      login: 'Sign In',
      requestDemo: 'Request Demo',
    },

    // Hero Section
    hero: {
      badge: 'Payment Control Platform',
      titlePart1: 'Uncover Your',
      titleHighlight: ' Silent Revenue ',
      titlePart2: 'Losses',
      description: 'Monitor every transaction in your payment infrastructure end-to-end. Detect lost, duplicate, or failed payments in a',
      descriptionBold: 'provable',
      descriptionEnd: 'way.',
      stat1Value: '%',
      stat1Label: 'Average Revenue Loss',
      stat2Value: ' min',
      stat2Label: 'Detection Time',
      stat3Value: '%',
      stat3Label: 'Accuracy Rate',
      ctaPrimary: 'Try Free',
      ctaSecondary: 'Watch Demo',
      trustedBy: 'Trusted by:',
    },

    // Problem Section
    problem: {
      tag: 'Problem',
      title: 'The Dark Side of',
      titleHighlight: 'Modern Payment Systems',
      subtitle: 'Payment flows become complex in distributed systems. Errors lost in logs silently turn into revenue loss.',
      cards: [
        {
          emoji: '💸',
          title: 'Silent Revenue Loss',
          description: 'Provider says success but order wasn\'t created. Nobody notices, money is lost.',
        },
        {
          emoji: '🔄',
          title: 'Double Transaction Risk',
          description: 'Webhook came multiple times, same payment processed twice due to retry.',
        },
        {
          emoji: '📱',
          title: 'Mobile Disconnection',
          description: 'App closed, payment left incomplete. User paid but didn\'t receive service.',
        },
        {
          emoji: '⏱️',
          title: 'Async Chaos',
          description: 'State lost under load balancer. Queue backlog formed, payments delayed.',
        },
        {
          emoji: '🔍',
          title: 'Lost in Log Hell',
          description: 'Thousands of log lines but no idea why a payment failed.',
        },
        {
          emoji: '📊',
          title: 'Invisible 1-5%',
          description: 'Companies don\'t notice 1-5% average revenue loss. Thousands of dollars vanishing monthly.',
        },
      ],
    },

    // Features Section
    features: {
      tag: 'Features',
      title: 'One Platform,',
      titleHighlight: 'Full Visibility',
      subtitle: 'Monitor every step of the payment lifecycle, detect anomalies instantly.',
      cards: [
        {
          title: 'Payment Timeline',
          description: 'Chronological state flow for each payment. Every step visible from INIT to REVENUE.',
        },
        {
          title: 'Lost Revenue Detection',
          description: 'Provider success but no DB record? Instant alert with estimated loss amount.',
        },
        {
          title: 'Webhook Tracking',
          description: 'Every incoming webhook is recorded. Retry count, processing status, timing analysis.',
        },
        {
          title: 'State Machine Validation',
          description: 'Catches invalid state transitions. SUCCESS without INIT? Instant flag.',
        },
        {
          title: 'Duplicate Detection',
          description: 'Double webhook or double revenue for same payment? Alert with risk level.',
        },
        {
          title: 'AI Explanation Engine',
          description: 'Why did losses increase this week? AI analyzes patterns, explains in human language.',
        },
      ],
      highlight: {
        title: 'When State Flow Breaks',
        description: 'System automatically detects anomaly, calculates estimated loss, and suggests actions.',
        features: ['Real-time detection', 'Confidence score calculation', 'Recommendation engine'],
      },
    },

    // How It Works Section
    howItWorks: {
      tag: 'How It Works',
      title: 'Full Visibility in',
      titleHighlight: '3 Steps',
      subtitle: 'Integration completes in minutes. Never interferes with your core payment flow.',
      steps: [
        {
          number: '01',
          title: 'SDK Integration',
          description: 'Add a small SDK to your backend. Works async and non-blocking, doesn\'t affect performance.',
        },
        {
          number: '02',
          title: 'Webhook Connection',
          description: 'Payments don\'t always disappear… Some just silently go missing.',
        },
        {
          number: '03',
          title: 'Monitor from Dashboard',
          description: 'Monitor all payments in real-time, see anomalies instantly, download reports.',
        },
      ],
      webhook: {
        provider: 'Payment Provider',
        yourApi: 'Your API',
      },
      metrics: {
        total: 'Total Payments',
        healthy: 'Healthy',
        risky: 'Risky',
        lost: 'Lost',
      },
      note: {
        title: 'Observer / Sidecar Architecture',
        description: 'SilentLoss works',
        descriptionBold: 'alongside',
        descriptionEnd: 'your system, never interferes. Even if it fails, your payments are unaffected. 100% safe integration.',
      },
      // Animation Flow
      animation: {
        scenarioHealthy: 'Healthy Payment Flow',
        scenarioLoss: 'Silent Loss Scenario',
        // Events
        events: {
          paymentInitiated: 'payment.initiated',
          processingPayment: 'provider.processing',
          providerSuccess: 'provider.success',
          merchantRecorded: 'merchant.recorded',
          silentlossConfirmed: 'silentloss.confirmed',
        },
        // Labels
        labels: {
          client: 'Client App',
          provider: 'Payment Provider',
          merchantServer: 'Merchant Server',
          silentloss: 'SilentLoss',
        },
        // Status messages
        status: {
          initiating: 'Payment Initiating',
          processing: 'Processing...',
          success: 'Success',
          recorded: 'Recorded',
          confirmed: 'Confirmed',
          waiting: 'Waiting...',
          missing: 'Missing Event',
          detected: 'Detected',
        },
        // Final messages
        healthyMessage: {
          title: 'Everything Looks Fine',
          subtitle: 'No payment loss detected.',
        },
        lossMessage: {
          title: 'Silent Loss Detected',
          subtitle: 'Payment succeeded but not recorded.',
          detail: 'This transaction would normally go unnoticed.',
        },
        // CTA
        cta: {
          title: 'Don\'t lose money silently.',
          subtitle: 'Detect payment gaps before your users do.',
        },
      },
    },

    // Dashboard Section
    dashboard: {
      tag: 'Dashboard',
      title: 'See Every Payment\'s',
      titleHighlight: 'Story',
      windowTitle: 'SilentLoss Dashboard',
      sidebar: {
        overview: 'Overview',
        payments: 'Payments',
        risks: 'Risks',
        reports: 'Reports',
      },
      stats: {
        totalPayment: 'Total Payment',
        healthy: 'Healthy',
        estimatedLoss: 'Estimated Loss',
        thisWeek: 'This week',
      },
      chart: {
        title: 'Payment Status (Last 7 Days)',
        days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      },
      timeline: {
        title: 'Recently Detected Problems',
        lostRevenue: 'Lost revenue',
        doubleWebhook: 'Double webhook',
        stateMismatch: 'State mismatch',
        timeout: 'Timeout',
      },
    },

    // AI Section
    ai: {
      tag: 'AI Powered',
      title: 'Understand Why',
      titleHighlight: 'You\'re Losing',
      description: 'AI engine doesn\'t just say "there\'s loss". It analyzes patterns, finds root cause, suggests actions.',
      quote: '"In this period,',
      quoteBold1: '70%',
      quoteMiddle: 'of payment losses occurred on Fridays between 8-10 PM due to',
      quoteBold2: 'load balancer retries',
      quoteEnd: '. I recommend increasing your webhook timeout threshold from 5 to 10 seconds."',
      meta: 'SilentLoss AI • Weekly Analysis',
      capabilities: [
        'Anomaly pattern detection',
        'Root cause analysis',
        'CFO-friendly summary reports',
        'Action recommendations',
      ],
      card: {
        title: 'Weekly AI Summary',
        new: 'New',
        insights: [
          { title: 'Loss Trend', value: '-23% (vs last week)' },
          { title: 'Main Pattern', value: 'Mobile timeout (iOS 17+)' },
          { title: 'Recommended Action', value: 'SDK timeout: 10s → 15s' },
        ],
      },
    },

    // Pricing Section
    pricing: {
      tag: 'Pricing',
      title: 'Transparent',
      titleHighlight: 'Pricing',
      subtitle: 'Predictable pricing that scales with your payment volume.',
      perMonth: '/mo',
      paymentsPerMonth: 'payments/mo',
      popular: 'Most Popular',
      selectButton: 'Select',
      startButton: 'Get Started',
      plans: [
        {
          name: 'Free Trial',
          price: 0,
          isFree: true,
          payments: '1,000',
          features: [
            '7 Day Free Trial',
            '1 Team Member',
            '7 Day Data Retention',
            'Payment Tracking',
            'Webhook Tracking',
            'Risk Detection',
          ],
        },
        {
          name: 'Basic',
          price: 19,
          payments: '5,000',
          features: [
            '2 Team Members',
            '14 Day Data Retention',
            'Payment Tracking',
            'Webhook Tracking',
            'Risk Detection',
            'Basic Dashboard',
          ],
        },
        {
          name: 'Standard',
          price: 49,
          payments: '20,000',
          popular: true,
          features: [
            '5 Team Members',
            '60 Day Data Retention',
            'Payment Tracking',
            'Webhook Tracking',
            'Risk Detection',
            'Risk Factor Comparison',
            'CSV Export',
          ],
        },
        {
          name: 'Pro',
          price: 99,
          payments: '75,000',
          features: [
            '10 Team Members',
            '180 Day Data Retention',
            'Payment Tracking',
            'Webhook Tracking',
            'Risk Detection',
            'Org Level Stats',
            'Risk Factor Comparison',
            'CSV Export',
          ],
        },
      ],
      audit: {
        title: 'Audit Mode',
        description: 'Let us monitor your system for 7-14 days and deliver a detailed PDF report. One-time fee.',
        price: '$1,000 - $5,000',
        button: 'Get Quote',
      },
    },

    // CTA Section
    cta: {
      title: 'Discover Your Lost Revenue',
      titleHighlight: 'Today',
      titleEnd: '',
      description: 'Try free for 14 days. No credit card required. Integrate in 5 minutes.',
      primaryButton: 'Start Free',
      secondaryButton: 'Schedule Demo',
      trust: {
        gdpr: 'GDPR Compliant',
        pci: 'Outside PCI Scope',
        uptime: '99.9% Uptime',
      },
    },

    // Footer
    footer: {
      description: 'An observation and verification platform that uncovers silent revenue losses in your payment infrastructure.',
      product: {
        title: 'Product',
        features: 'Features',
        pricing: 'Pricing',
        howItWorks: 'How It Works',
        documentation: 'Documentation',
      },
      company: {
        title: 'Company',
        about: 'About Us',
        blog: 'Blog',
        careers: 'Careers',
        contact: 'Contact',
      },
      support: {
        title: 'Support',
        helpCenter: 'Help Center',
        apiReference: 'API Reference',
        status: 'Status',
        security: 'Security',
      },
      legal: {
        copyright: '© 2026 SilentLoss. All rights reserved.',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        kvkk: 'GDPR',
      },
    },
  },
};
